var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getQuery, env } from '@funny/env';
import sensors from 'sa-sdk-javascript';
var DEFAULT_SERVER_URL = 'https://lc.zt.changba.com/collectH5';
var isInitialized = false;
/**
 * 初始化埋点配置，可在活动入口手动调用调整配置
 * @param option
 */
export function trackInit(option) {
    if (option === void 0) { option = {}; }
    sensors.init({
        server_url: option.server_url || DEFAULT_SERVER_URL,
        send_type: option.send_type || 'beacon',
        show_log: option.show_log === true,
    });
    sensors.registerPage({
        enter_source: getQuery('refsrc') || 'none',
        platform_type: 'javascript',
        data_version: 1,
    });
    sensors.login(env.userInfo.userId);
    isInitialized = true;
}
function trackEvent(content, params) {
    if (params === void 0) { params = {}; }
    if (!isInitialized) {
        trackInit();
    }
    sensors.track(content, params);
}
export var track = trackEvent;
/**
 * 页面曝光埋点统计
 * @param params 补充埋点数据
 */
export function trackPv(params) {
    if (params === void 0) { params = {}; }
    trackEvent('show_page_H5', params);
}
/**
 * 元素点击埋点统计（包房业务/KTV）
 * @param content 点击的内容
 * @param params 补充埋点数据
 */
export function trackElClick(content, params) {
    if (params === void 0) { params = {}; }
    trackEvent('click_element_H5_ktv', __assign(__assign({}, params), { element_content_ktv: content }));
}
/**
 * trackElClick的别名
 */
export var trackElClickH5KTV = trackElClick;
/**
 * 元素点击埋点统计（其他业务）
 * @param content 点击的内容
 * @param params 额外需要补充的埋点数据
 */
export function trackElClickH5(content, params) {
    if (params === void 0) { params = {}; }
    trackEvent('click_element_H5', __assign(__assign({}, params), { element_content: content }));
}
/**
 * 页面停留时长统计，进入页面时调用一次
 */
export function trackTp() {
    var enterTime = window.performance.now();
    document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') {
            enterTime = window.performance.now();
        }
        else {
            trackEvent('show_end', {
                duration: Math.round((window.performance.now() - enterTime) / 1000),
                scene: 'H5',
            });
        }
    });
}
